module.exports = __webpack_public_path__ + "img/Bio.7cb1102f.png";